import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-audit-log-events-export',
  templateUrl: './audit-log-events-export.component.html',
  styleUrls: ['./audit-log-events-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditLogEventsExportComponent {
  readonly disabled = input(false);
  readonly waitingForFile = input(false);
  readonly displayCheckMark = input(false);
  readonly tooltipKey = input('common.export');

  readonly exportClick = output<void>();

  public exportToCSV(): void {
    if (this.disabled() || this.waitingForFile()) {
      return;
    }
    this.exportClick.emit();
  }
}
